import { render, staticRenderFns } from "./RHeading.vue?vue&type=template&id=3fb2ef80&scoped=true"
import script from "./RHeading.vue?vue&type=script&lang=js"
export * from "./RHeading.vue?vue&type=script&lang=js"
import style0 from "./RHeading.vue?vue&type=style&index=0&id=3fb2ef80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb2ef80",
  null
  
)

export default component.exports